export default __webpack_public_path__ + "static/media/NoEmotionAi.85855b2e.png";